import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#242526",
      d: "M3.473 14.465a1.18 1.18 0 0 1-.867-.355 1.18 1.18 0 0 1-.356-.868V4.19q0-.513.356-.868a1.18 1.18 0 0 1 .867-.355h.937v-.928a.48.48 0 0 1 .149-.36.5.5 0 0 1 .371-.143.51.51 0 0 1 .52.52v.91h5.126v-.94q0-.21.145-.35a.5.5 0 0 1 .362-.14.5.5 0 0 1 .361.146.5.5 0 0 1 .146.361v.924h.937q.511 0 .868.355.355.355.355.868v9.053q0 .513-.355.868a1.18 1.18 0 0 1-.868.355H3.473Zm0-1.015h9.054q.09 0 .15-.058a.2.2 0 0 0 .058-.15V6.894h-9.47v6.348q0 .09.059.15a.2.2 0 0 0 .15.058Zm-.208-7.57h9.47V4.189a.2.2 0 0 0-.059-.15.2.2 0 0 0-.15-.059H3.474q-.09 0-.15.059a.2.2 0 0 0-.058.15v1.69Z",
      class: "change-color-fill"
    }, null, -1)
  ]))]))
}
export default { render: render }